// extracted by mini-css-extract-plugin
export default {"container":"BalanceSheet_container__AQxLP","totalContainer":"BalanceSheet_totalContainer__GHwZW","arithmeticOperator":"BalanceSheet_arithmeticOperator__j-riJ"};